enum CaseStatus {
  ACTIVE = "ACTIVE",
  SUBMITTED = "SUBMITTED",
  PENDING = "PENDING",
  ARCHIVED = "ARCHIVED",
}

export default CaseStatus;
